import _styled from "@emotion/styled/base";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useBreakpointDown } from '@travel-frontend/core';
import { IconArrowUpward } from '@travel-frontend/icons';
import { forwardRef, memo, useEffect, useState } from 'react';
import { Button } from '../../components/BackToTop/components/Button.js';
import { Fade } from '../../primitives/index.js';
import { Portal } from '../../primitives/internal/Portal/index.js';
const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
};
export const BackToTop = memo(/*#__PURE__*/_styled(forwardRef(({
  scrollOffset = 0,
  initialVisible = false,
  children,
  ...restProps
}, ref) => {
  const mdDown = useBreakpointDown('md');
  const [visible, setVisible] = useState(initialVisible);
  useEffect(() => {
    const updateVisibilityState = scrollPos => {
      setVisible(scrollPos > scrollOffset);
    };
    const handleScroll = () => {
      updateVisibilityState(window.scrollY);
    };
    updateVisibilityState(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [visible, scrollOffset]);
  return _jsx(Portal, {
    children: _jsx(Fade, {
      in: visible,
      children: _jsx(Button, {
        ...restProps,
        ref: ref,
        variant: "neutral",
        icon: _jsx(IconArrowUpward, {}),
        onClick: scrollToTop,
        iconOnly: mdDown,
        "aria-label": typeof children === 'string' ? children : undefined,
        children: !mdDown && children
      })
    })
  });
}), process.env.NODE_ENV === "production" ? {
  target: "ebwud9b0"
} : {
  target: "ebwud9b0",
  label: "BackToTop"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));